import { FontelloIconMap, isFontelloIcon } from './FontelloIconMap'

export { FontelloIconMap, isFontelloIcon } from './FontelloIconMap'

export default {
    FontelloIconMap,
    isFontelloIcon,
}
